
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-query_stats",
  "use": "icon-material-query_stats-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-query_stats\"><path d=\"m90.2-247.57-55.7-40.78 193.02-308.13L343.75-460.3l155.84-252.27 114.02 169.9q-17.91 2.71-34.47 8.53-16.55 5.81-32.75 13.97l-43.56-66.85L354.81-345.2 236.48-482.37zM876.76-34.5 742.04-169.22q-20.76 14.52-44.9 22.05-24.14 7.52-49.42 7.52-71.79 0-122.21-50.46-50.42-50.45-50.42-122.29t50.45-122.3q50.46-50.45 122.3-50.45 71.83 0 122.17 50.54t50.34 122.33q0 25.52-8.14 49.54t-21.43 46.23L925.5-83.48zM647.58-207.78q43.75 0 74.19-30.31 30.45-30.3 30.45-74.05t-30.31-74.32q-30.3-30.56-74.05-30.56t-74.2 30.42q-30.44 30.43-30.44 74.18t30.3 74.19q30.31 30.45 74.06 30.45m77.49-324.65q-17.4-7.2-35.79-9.2t-37.54-3.28L870.04-891l55.46 40.78z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-query_stats"/>
                </svg>
            );
        };

        Icon.id = "icon-material-query_stats";

        export default Icon;
    